import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ActivityIndicator,
  Image,
} from 'react-native';

export function SplashScreen() {
  return (
    <View style={styles.container}>
      <Image
        source={{ uri: '/public/logo_light.png' }}
        style={styles.logoImage}
        resizeMode="contain"
      />
      <ActivityIndicator size="large" color="#ff6b00" style={styles.spinner} />
      <Text style={styles.subtitle}>Carregando...</Text>
    </View>
  );
}

export default SplashScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoImage: {
    width: 200,
    height: 80,
    marginBottom: 30,
  },
  spinner: {
    marginVertical: 20,
  },
  subtitle: {
    color: '#999',
    fontSize: 14,
    marginTop: 20,
  },
});
